import Axios from 'axios'
import { Message } from 'element-ui'
import config from '@/config/ApiConfig'
import loading from './loading'
import {getBrowserInfo} from '@/utils'
const baseVersion = 'v1.0'
const request = Axios.create({
    baseURL: config.apiServer,
    timeout: 5000,
    // xhrFields: {
    //     withCredentials: true
    // },
    crossDomain: true,
    withCredentials: true
})
// 添加请求拦截器
request.interceptors.request.use(
    function(config) {
        if (config.showLoading) {
            loading.addUrl(config.url)
        }

        // console.log(config)
        const token = localStorage.getItem('token')
        if (!config.headers.token && token) {
            config.headers.token = token
        }
        // console.log(config)
        return config
    },
    function(error) {
        return Promise.reject(error)
    }
)
// 添加响应拦截器
request.interceptors.response.use(
    function(res) {
        setTimeout(()=>{
            loading.removeUrl(res.config.url)
        },800)
        
        const result = res.data
        if (result.code === 401) {
            localStorage.removeItem('token')
            //清除用户类型，避免管理员登录超时后切换学生身份无法报名
            localStorage.removeItem('type');
            window.location.replace('#/login')
            // if (window.location.hash !== '#/login') {
            //     window.location.reload()
            // }
            // console.log('未登录哟')
            throw new Error('用户未登录!')
        }
        return result
    },
    function(error) {
        return Promise.reject(error)
    }
)
class Http {
    /**
     * 构造方法
     * moduleUrl:对应模块的路径前缀
     * 可以多种方式传参:
     * 方式一:
     * new Http('userInfo')
     * 方式二:
     * new Http({url:'userInfo',version:'v2'})
     *
     * extendsFns:扩展的其它方法
     */
    constructor(moduleUrl, extendsFns = {}) {
        if (typeof moduleUrl === 'string') {
            this.moduleUrl = moduleUrl + '/'
        } else {
            var { url, version } = moduleUrl
            this.moduleUrl = url + '/' + version + '/'
        }
        Object.keys(extendsFns).forEach(keys => {
            var fns = extendsFns[keys]
            // 赋值给当前实例的http对象
            this[keys] = fns
        })
    }
    // get请求
    get(url, params, showLoading = true) {
        // 请求加上时间戳,防止304缓存问题
        var timer = new Date().getTime().toString()
        url = url === undefined ? 'list' : url
        url = this.moduleUrl + url + '?' + timer
        return this.ajax({
            url,
            params,
            showLoading
        })
    }
    // post请求
    post(url, data, showLoading = true,config={}) {
        url = this.moduleUrl + url
        const method = 'POST'
        return this.ajax({
            url,
            data,
            method,
            showLoading,
            ...config
        })
    }
    /**
     * 其他方式
     */
    save(item, url = 'save') {
        return this.post(url, item)
    }
    /**
     * @param: ids:字符串或数组
     */
    delete(url, data, showLoading = true) {
        url = this.moduleUrl + url
        const method = 'DELETE'
        return this.ajax({
            url,
            data,
            method,
            showLoading
        })
    }
    // deleteById (id) {
    //   let param = {}
    //   if (typeof id === 'object') {
    //     param.ids = id
    //   } else {
    //     param.id = id
    //   }
    //   return this.delete(param)
    // }
    // put (item) {
    //   return this.save(item, 'update')
    // }
    add(item) {
        return this.post('add', item)
    }
    // // data: FromData类型
    upload(url, data, showLoading = true) {
        const method = 'POST'
        url = url === undefined ? 'upload' : url
        url = this.moduleUrl + url
        return this.ajax({
            url,
            data,
            method,
            showLoading,
            timeout:'50000',
            headers: {
                'Content-Type': 'multipart/form-data'
            }
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' }
        })
    }
    downloadFile(url, data, showLoading = true,config={}){
        // 判断浏览器版本
        console.log(window.navigator.userAgent)
        if(getBrowserInfo().type=='IE'&&getBrowserInfo().version<9){
           alert('系统检测到您正在使用ie9以下内核的浏览器,请更换或升级浏览器访问！')
            return false;
        }
        if(!is360se()){
            alert('请切换360极速模式')
            return false;
        }
        url = this.moduleUrl + url
        const method = 'POST'
        return this.ajax({
            url,
            data,
            method,
            showLoading,
            timeout:'50000',
            ...config
        })
    }
    // 获取文件流下载
    getFileBinarySystem(url, data, method = 'POST', showLoading = true) {
        url = this.moduleUrl + url
        const responseType = 'blob'
        var requestData = {}
        if (method === 'GET') {
            requestData = {
                url,
                params: data,
                responseType,
                showLoading
            }
        } else {
            requestData = {
                url,
                data,
                method,
                responseType,
                showLoading
            }
        }
        return request.request({...requestData,timeout:'50000'}).then(res => {
            return res
        }).catch(error => {
            this.$message.error('没有可导出数据')
            throw new Error('没有数据')
        })
        // return this.ajax({...requestData,timeout:'50000'})
    }
    ajax(config) {
        return request.request(config).then(res => {
            if (res.code === 200) {
                return res.data
            } else {
                return this.error(res)
            }
        }, this.error).catch((e)=>{
            console.log(e,'捕获')
            throw new Error(e);
        })
    }
    error(data) {
        console.log(data)
        // console.log(data)
        let message = data.message
        if (message === 'Network Error') {
            message = '连接超时'
           // window.location.replace('#/login')
        } else if (!message) {
            message = '后台接口空指针异常...'
        } else if (message.indexOf('404') > -1) {
            message = '接口未找到...'
        }
        Message.error(message)
        const error = new Error(message)
        error.code = data.code
        loading.clearLoading()
        return Promise.reject(message)
    }
}
export default Http
function is360se(){
    var where = "suffixes", value = "dll", name = "description", nameReg = /fancy/;
    var mimeTypes = window.navigator.mimeTypes, i;
    for (i in mimeTypes) {
        if (mimeTypes[i][where] == value) {
            if (nameReg.test(mimeTypes[i][name])) return false;
        }
    }
    return true;
}
